import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { deleteObject, ref } from "firebase/storage";
import { enqueueSnackbar } from "notistack";
import { database, storage } from "../../lib/cliente";
import { Sonho } from "../../types";

const SonhoCollection = collection(database, "sonhos");

export class SonhoServiceClass {
  private static _instance: SonhoServiceClass;

  static getInstance(): SonhoServiceClass {
    if (!this._instance) {
      this._instance = new SonhoServiceClass();
    }

    return this._instance;
  }

  async addSonho(data: Sonho) {
    try {
      const docRef = await addDoc(SonhoCollection, {
        ...data,
        createdAt: serverTimestamp(),
      });

      await updateDoc(docRef, {
        id: docRef.id,
      });
      enqueueSnackbar("Sonho adicionado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }

  async getSonhos(): Promise<Sonho[] | undefined> {
    const pacotesQuery = query(SonhoCollection, orderBy("createdAt", "desc"));
    const pacotes = await getDocs(pacotesQuery);

    return pacotes.docs.map((item) => ({
      ...item.data(),
    })) as Sonho[];
  }

  async getSonho(id: string): Promise<Sonho | undefined> {
    const docRef = doc(SonhoCollection, id);

    try {
      const res = await getDoc(docRef);

      return res.data() as Sonho;
    } catch (err) {
      console.log(err);
    }
  }

  async deleteImages(data: string[]) {
    try {
      await Promise.all(
        data.map(async (imageUrl) => {
          // Extrair o nome do arquivo a partir da URL (opcional, dependendo da sua estrutura de armazenamento)
          const fileName = extractFileNameFromUrl(imageUrl);
          const fileRef = ref(storage, `images/${fileName}`);

          await deleteObject(fileRef);
        })
      );
    } catch (err) {
      console.log("Error:", err);
    }
  }

  async deleteSonho(data: Sonho) {
    try {
      const docRef = doc(SonhoCollection, data.id);

      await Promise.all(
        data.imagesUrl.map(async (imageUrl) => {
          // Extrair o nome do arquivo a partir da URL (opcional, dependendo da sua estrutura de armazenamento)
          const fileName = extractFileNameFromUrl(imageUrl);
          const fileRef = ref(storage, `images/${fileName}`);

          await deleteObject(fileRef);
        })
      );
      await deleteDoc(docRef);

      enqueueSnackbar("Sonho deletado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log("Error:", err);

      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }

  async updateSonho(data: Sonho) {
    try {
      const docRef = doc(SonhoCollection, data.id);

      await updateDoc(docRef, {
        ...data,
      });
      enqueueSnackbar("Sonho atualizado com sucesso!", {
        variant: "success",
      });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Algo deu errado! Tente novamente", {
        variant: "error",
      });
    }
  }
}

const extractFileNameFromUrl = (url: string) => {
  const regex = /%2F(.+?)\?/;
  const match = url.match(regex);
  if (match && match[1]) {
    const fileNameWithSpaces = decodeURIComponent(match[1].replace(/\+/g, " "));
    return fileNameWithSpaces;
  }
  return null;
};

export const SonhoService = SonhoServiceClass.getInstance();
